import axios from 'CanExConfig/axios'

export const submitPostLiveReason = async ({ post_live_reason, other_reason }, id) => {
  const response = await axios(`/candidate/${id}/dashboard/hide_profile`, {
    method: 'post',
    data: {
      post_live_reason,
      other_reason,
    },
  })

  return response.data
}
